import {
    type FC
} from "react";
import {
    Pressable,
    View
} from "react-native";
import type IAttachmentTriggerProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useInteractionState
} from "../../../../helpers/interaction";
import type {
    AttachmentPartContentProps
} from "../../type";
import {
    withAttachmentContext
} from "../../context";
import StateLayer from "../../../stateLayer";

const AttachmentTriggerContent: FC<AttachmentPartContentProps<IAttachmentTriggerProps>> = ({
    "aria-label": ariaLabel,
    onPress: onPressProp,
    accessibilityLabel,
    role = "button",
    customTheme,
    onHoverOut,
    onPressOut,
    onHoverIn,
    onPressIn,
    context,
    onFocus,
    onBlur,
    style,
    ...props
}) => {
    const currentTheme = customTheme ?? context.customTheme;

    const {
        shapeConfigs,
        borders,
        colors
    } = NCoreUIKitTheme.useContext(currentTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    const {
        interactionHandlers,
        isFocusVisible,
        isHovered,
        isPressed
    } = useInteractionState({
        onHoverOut,
        onPressOut,
        onHoverIn,
        onPressIn,
        onFocus,
        onBlur
    });

    const {
        container: containerDynamicStyle,
        surface: surfaceDynamicStyle
    } = useStyles({
        borderRadius: context.borderRadius,
        isFocusVisible,
        shapeConfigs,
        borders,
        colors
    });

    return <Pressable
        {...props}
        {...interactionHandlers}
        accessibilityLabel={accessibilityLabel ?? (ariaLabel ? undefined : localize("preview-attachment", [
            context.title ?? ""
        ]))}
        onPress={onPressProp ?? context.onPress}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-label={ariaLabel}
        role={role}
    >
        <View
            style={[
                stylesheet.surface,
                surfaceDynamicStyle
            ]}
        >
            <StateLayer
                borderRadius={context.borderRadius}
                customTheme={currentTheme}
                borderWidth={borders.line}
                isHovered={isHovered}
                isPressed={isPressed}
                isSquircle={true}
            />
        </View>
    </Pressable>;
};
export default withAttachmentContext("Trigger", AttachmentTriggerContent);
